import { Component, Input } from '@angular/core';
import { SafeHtmlPipePipe } from '../pipes/safe-html.pipe';

@Component({
    selector: 'rn-input-info-box',
    templateUrl: './input-info-box.component.html',
    styleUrls: ['./input-info-box.component.scss'],
    standalone: true,
    imports: [SafeHtmlPipePipe]
})
export class InputInfoBoxComponent {
  @Input() text: string = null;
  @Input() svgHeight: number = null;
  @Input() svgPosition: string = null;
}
